module.exports = __webpack_public_path__ + "449d3be8d7fe0f585975c762ea94ae0a.svg";